/**
 * THIS FILE IS GENERATED, DO NOT DIRECTLY EDIT
 */
import { ContractPairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/types';
import { ChainId } from '@ui/types/chain';

export const pairs_v4_raw = {
  10143: [
    {
      name: 'BTC/USD',
      base: '0xcf5a6076cfa32686c0Df13aBaDa2b40dec133F1d',
      basePosition: 0,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      maxShortOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      fundingFeePerSecondP: { __type: 'bigint', value: '160540567946' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 0,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 0,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'ETH/USD',
      base: '0xB5a30b0FDc5EA94A52fDc42e3E9760Cb8449Fb37',
      basePosition: 1,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      maxShortOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      fundingFeePerSecondP: { __type: 'bigint', value: '240138146467' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 1,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 1,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'SOL/USD',
      base: '0x0a3ec4fc70EaF64fAf6EeDa4e9b2Bd4742a78546',
      basePosition: 2,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      maxShortOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      fundingFeePerSecondP: { __type: 'bigint', value: '305175266071' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 2,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 2,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'XRP/USD',
      base: '0xaEb724422620edb430DCAf22aEeFF2E9388a578c',
      basePosition: 3,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      maxShortOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      fundingFeePerSecondP: { __type: 'bigint', value: '241485391637' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 2,
      slippagePosition: 0,
      slippageConfig: {
        name: '0.3% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 5,
        slippageShortP: 5,
        index: 2,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 3,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: '500BTC/USD',
      base: '0x0000000000000000000000000000000000000003',
      basePosition: 4,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      maxShortOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      fundingFeePerSecondP: { __type: 'bigint', value: '160540567946' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '158333333333' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '7000000000000000000000000' },
          tier: 1,
          maxLeverage: 1001,
          initialLostP: 7500,
          liqLostP: 8000,
        },
      ],
      slippageConfigIndex: 1,
      slippagePosition: 0,
      slippageConfig: {
        name: 'degen 0.02% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 0,
        slippageShortP: 0,
        index: 1,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 1,
      feePosition: 0,
      feeConfig: {
        name: 'Degen mode',
        index: 1,
        openFeeP: 0,
        closeFeeP: 0,
        enable: true,
        shareP: 85000,
        minCloseFeeP: 70,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 666,
      shortHoldingFeeRate: 666,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: '500ETH/USD',
      base: '0x0000000000000000000000000000000000000004',
      basePosition: 5,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      maxShortOiUsd: { __type: 'bigint', value: '1800580362637442697976546' },
      fundingFeePerSecondP: { __type: 'bigint', value: '240138146467' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '158333333333' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '7000000000000000000000000' },
          tier: 1,
          maxLeverage: 1001,
          initialLostP: 7500,
          liqLostP: 8000,
        },
      ],
      slippageConfigIndex: 1,
      slippagePosition: 1,
      slippageConfig: {
        name: 'degen 0.02% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 0,
        slippageShortP: 0,
        index: 1,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 1,
      feePosition: 1,
      feeConfig: {
        name: 'Degen mode',
        index: 1,
        openFeeP: 0,
        closeFeeP: 0,
        enable: true,
        shareP: 85000,
        minCloseFeeP: 70,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 666,
      shortHoldingFeeRate: 666,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'AAPL/USD',
      base: '0x3a54a9A690616Fbc26CfC409BF11F89d51f1d57a',
      basePosition: 6,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '260835277546' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 4,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 0,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'AMZN/USD',
      base: '0x6C755094F1Cdd95e2e4170549dc12e7555151536',
      basePosition: 7,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '278403774325' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 5,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 1,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'MSFT/USD',
      base: '0xB2023082F01404DD0CE6937cAb03C4f5d6db9bA8',
      basePosition: 8,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '280680093206' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 6,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 2,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'GOOG/USD',
      base: '0x9a4f772DE1a5F6DF5913fA2C98dD7177eaA23Dc2',
      basePosition: 9,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '250060616780' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 7,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 3,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'TSLA/USD',
      base: '0x0A8F1F385feD9c77A2e0daA363cCc865e971bdBE',
      basePosition: 10,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '336623127380' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 8,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 4,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'NVDA/USD',
      base: '0xE108948b9667048232851F26A1427d3a908B22da',
      basePosition: 11,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '193649393173' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 9,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 5,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'META/USD',
      base: '0x0057355892FAB25DdC63a7482eC1696D6aDa6703',
      basePosition: 12,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '178915524216' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 10,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 6,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'XAU/USD',
      base: '0x7C687a3207CD9c05B4b11d8DD7Ac337919c22001',
      basePosition: 13,
      pairType: 4,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '122068214082' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 11,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 7,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'XAG/USD',
      base: '0x5cCc5C04130D272Bf07D6e066f4caE40CFC03136',
      basePosition: 14,
      pairType: 4,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '237147719697' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 12,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 8,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'QQQ/USD',
      base: '0xb589511C51D1fFdA5D943Ac1c9733e112aBEfF7B',
      basePosition: 15,
      pairType: 3,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '166632720687' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 1,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 9,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'SPY/USD',
      base: '0xcb8900160Bd4A86D3b80f5ad5A44EE15823B0592',
      basePosition: 16,
      pairType: 3,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '72776623746' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 5,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 10,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'EUR/USD',
      base: '0xA9226449042E36BF6865099eEC57482aa55E3aD0',
      basePosition: 17,
      pairType: 2,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '26524589907' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 15,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 11,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 317,
      shortHoldingFeeRate: 317,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'USD/JPY',
      base: '0x35b8BAfFF3570683Af968B8D36B91b1a19465141',
      basePosition: 18,
      pairType: 2,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '37317684360' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 16,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 12,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 317,
      shortHoldingFeeRate: 317,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'MON/USD',
      base: '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
      basePosition: 19,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      maxShortOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      fundingFeePerSecondP: { __type: 'bigint', value: '673368516370' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '158333333333' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 25,
          initialLostP: 7500,
          liqLostP: 8000,
        },
      ],
      slippageConfigIndex: 4,
      slippagePosition: 0,
      slippageConfig: {
        name: '0.15% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 15,
        slippageShortP: 15,
        index: 4,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 4,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: {
        __type: 'bigint',
        value: '40000000000000000000000',
      },
      minHoldingSeconds: { __type: 'bigint', value: '180' },
    },
    {
      name: 'UNI/USD',
      base: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
      basePosition: 20,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      maxShortOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      fundingFeePerSecondP: { __type: 'bigint', value: '427782846908' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 0,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 5,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'DOGE/USD',
      base: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
      basePosition: 21,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '269077453052' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 2,
      slippagePosition: 1,
      slippageConfig: {
        name: '0.3% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 5,
        slippageShortP: 5,
        index: 2,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 6,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'ZEC/USD',
      base: '0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb',
      basePosition: 22,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '441494687808' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 25,
          initialLostP: 7500,
          liqLostP: 8000,
        },
      ],
      slippageConfigIndex: 4,
      slippagePosition: 1,
      slippageConfig: {
        name: '0.15% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 15,
        slippageShortP: 15,
        index: 4,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 7,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: {
        __type: 'bigint',
        value: '40000000000000000000000',
      },
      minHoldingSeconds: { __type: 'bigint', value: '180' },
    },
    {
      name: 'KPEPE/USD',
      base: '0x721d0151AC1740353C14798db0C464B8C0116cc3',
      basePosition: 23,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '519493306208' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 2,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 8,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'LIT/USD',
      base: '0x232CE3bd40fCd6f80f3d55A522d03f25Df784Ee2',
      basePosition: 24,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '717839841903' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 5,
          initialLostP: 7500,
          liqLostP: 8000,
        },
      ],
      slippageConfigIndex: 4,
      slippagePosition: 2,
      slippageConfig: {
        name: '0.15% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 15,
        slippageShortP: 15,
        index: 4,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 9,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: {
        __type: 'bigint',
        value: '40000000000000000000000',
      },
      minHoldingSeconds: { __type: 'bigint', value: '180' },
    },
    {
      name: 'XMR/USD',
      base: '0xa5E34D2f9b8f4A05d531B5CC03e06624285B7A00',
      basePosition: 25,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '256805192896' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 25,
          initialLostP: 7500,
          liqLostP: 8000,
        },
      ],
      slippageConfigIndex: 4,
      slippagePosition: 3,
      slippageConfig: {
        name: '0.15% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 15,
        slippageShortP: 15,
        index: 4,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 10,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: {
        __type: 'bigint',
        value: '40000000000000000000000',
      },
      minHoldingSeconds: { __type: 'bigint', value: '180' },
    },
    {
      name: 'ADA/USD',
      base: '0xE9d95d048d2A009f6286570e4ad419Dbba8490EF',
      basePosition: 26,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '602057123498' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 3,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 11,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'SUI/USD',
      base: '0x6Df098aC2087Ddd7401A9A9F19e0D60D4f07BB17',
      basePosition: 27,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '312365477263' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 4,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 12,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'HYPE/USD',
      base: '0xC5f3D8462b1Cf323F17cd65568a8349b94a47e41',
      basePosition: 28,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '337699952593' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 2,
      slippagePosition: 4,
      slippageConfig: {
        name: '0.3% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 5,
        slippageShortP: 5,
        index: 2,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 13,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'LINK/USD',
      base: '0x062e57BcF79Ec1579Df888E32A3F07Cc899dc60A',
      basePosition: 29,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '248314715125' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 3,
      slippagePosition: 6,
      slippageConfig: {
        name: '0.05% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 10,
        slippageShortP: 10,
        index: 3,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 14,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'AUD/USD',
      base: '0xF4940d379CDb765b9E0430725c0C9Efb14A767ce',
      basePosition: 30,
      pairType: 2,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '31833348245' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 13,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 4,
      feePosition: 0,
      feeConfig: {
        name: 'forex fee rate',
        index: 4,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 317,
      shortHoldingFeeRate: 317,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'USD/CNH',
      base: '0x54b8e78c6c147de36b4914b070365Df449151317',
      basePosition: 31,
      pairType: 2,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      maxShortOiUsd: { __type: 'bigint', value: '360116072527488539595309' },
      fundingFeePerSecondP: { __type: 'bigint', value: '13479917916' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 14,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 4,
      feePosition: 1,
      feeConfig: {
        name: 'forex fee rate',
        index: 4,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 317,
      shortHoldingFeeRate: 317,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'MSTR/USD',
      base: '0x3aE04EaB3C283c5516C3958271264Ba9DBafCb4E',
      basePosition: 32,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '690764173894' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 10,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 3,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 13,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'CRCL/USD',
      base: '0xDF104b3DdF24cECE9843178cCc86A2152B3A4e07',
      basePosition: 33,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '393730097510' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 22,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 14,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'NFLX/USD',
      base: '0x3d9Fd1a881e7e0C02c76071F9e565D22A300cC73',
      basePosition: 34,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '255036324154' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 21,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 15,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'AMD/USD',
      base: '0x673187b2142Ef3CfF8A77799A3F207126FF02C55',
      basePosition: 35,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '329423668344' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 20,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 16,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'XPT/USD',
      base: '0xc88Cc73C99870BbA0314F459398b92Ca9BdC5dd6',
      basePosition: 36,
      pairType: 4,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '215932551268' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 19,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 5,
      feePosition: 0,
      feeConfig: {
        name: 'commodities fee rate',
        index: 5,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'XPD/USD',
      base: '0xe426Fb9717F3813cc76A3271587d9BEc13875f8D',
      basePosition: 37,
      pairType: 4,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '226108535667' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 17,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 5,
      feePosition: 1,
      feeConfig: {
        name: 'commodities fee rate',
        index: 5,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'TSM/USD',
      base: '0xAD1FA1fDcF0D5E63722D43fb25F8eD3D51D3C074',
      basePosition: 38,
      pairType: 1,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      maxShortOiUsd: { __type: 'bigint', value: '900290181318721348988273' },
      fundingFeePerSecondP: { __type: 'bigint', value: '374693625873' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 100,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 0,
      slippagePosition: 18,
      slippageConfig: {
        name: 'Default 0.01% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 1,
        slippageShortP: 1,
        index: 0,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 2,
      feePosition: 17,
      feeConfig: {
        name: 'stocks fee rate',
        index: 2,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'BNB/USD',
      base: '0x160A9630e8B9343f7fCCdEcF67BF1a59FE8d2B58',
      basePosition: 39,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      maxShortOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      fundingFeePerSecondP: { __type: 'bigint', value: '175409661148' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 2,
      slippagePosition: 2,
      slippageConfig: {
        name: '0.3% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 5,
        slippageShortP: 5,
        index: 2,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 15,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
    {
      name: 'TRX/USD',
      base: '0x601e2aa61d4354b3E5dBcB86733Bac211C073A4e',
      basePosition: 40,
      pairType: 0,
      status: 0,
      maxLongOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      maxShortOiUsd: { __type: 'bigint', value: '270087054395616404696481' },
      fundingFeePerSecondP: { __type: 'bigint', value: '80910737823' },
      minFundingFeeR: { __type: 'bigint', value: '3333333333' },
      maxFundingFeeR: { __type: 'bigint', value: '380000000000' },
      leverageMargins: [
        {
          notionalUsd: { __type: 'bigint', value: '3500000000000000000000000' },
          tier: 1,
          maxLeverage: 50,
          initialLostP: 8000,
          liqLostP: 8500,
        },
      ],
      slippageConfigIndex: 2,
      slippagePosition: 3,
      slippageConfig: {
        name: '0.3% fixed slippage',
        onePercentDepthAboveUsd: { __type: 'bigint', value: '0' },
        onePercentDepthBelowUsd: { __type: 'bigint', value: '0' },
        slippageLongP: 5,
        slippageShortP: 5,
        index: 2,
        slippageType: 0,
        enable: true,
        longThresholdUsd: { __type: 'bigint', value: '0' },
        shortThresholdUsd: { __type: 'bigint', value: '0' },
      },
      feeConfigIndex: 0,
      feePosition: 16,
      feeConfig: {
        name: 'Default Fee Rate',
        index: 0,
        openFeeP: 7,
        closeFeeP: 7,
        enable: true,
        shareP: 0,
        minCloseFeeP: 0,
        lvTokenDiscountP: 5000,
      },
      longHoldingFeeRate: 951,
      shortHoldingFeeRate: 951,
      holdingTimeThresholdSizeUSD: { __type: 'bigint', value: '0' },
      minHoldingSeconds: { __type: 'bigint', value: '0' },
    },
  ],
} as unknown as Record<ChainId, ContractPairsV4[]>;
